import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Search, Inbox, Settings2, TicketPercent, FileText, ShoppingCart, LogOut, Gauge, KeyRound, Quote } from "lucide-react";
import { clearAdminToken } from "@/lib/api";

export const ADMIN_NAV = [
  { to: "/admin", label: "Genel bakış", icon: LayoutDashboard, end: true, testid: "admin-nav-overview" },
  { to: "/admin/arama", label: "İşletme arama", icon: Search, testid: "admin-nav-search" },
  { to: "/admin/gelen-kutusu", label: "Gelen kutusu", icon: Inbox, testid: "admin-nav-inbox" },
  { to: "/admin/siparisler", label: "Siparişler", icon: ShoppingCart, testid: "admin-nav-orders" },
  { to: "/admin/hizmetler", label: "Hizmetler ve fiyatlar", icon: Settings2, testid: "admin-nav-services" },
  { to: "/admin/indirim-kodlari", label: "İndirim kodları", icon: TicketPercent, testid: "admin-nav-discounts" },
  { to: "/admin/eksik-olcumler", label: "Eksik ölçümler", icon: Gauge, testid: "admin-nav-backfill" },
  { to: "/admin/anahtar-kelimeler", label: "Anahtar kelimeler", icon: KeyRound, testid: "admin-nav-keywords" },
  { to: "/admin/sayfalar", label: "Sayfalar", icon: FileText, testid: "admin-nav-pages" },
  { to: "/admin/yorumlar", label: "Müşteri yorumları", icon: Quote, testid: "admin-nav-testimonials" },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <nav
        data-testid="admin-nav"
        className="border-b bg-background px-4 sm:px-6 lg:px-8 flex flex-wrap items-center gap-1 py-2"
        aria-label="Yönetim menüsü"
      >
        {ADMIN_NAV.map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium ${
                isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary"
              }`
            }
          >
            <Icon className="h-4 w-4" aria-hidden />
            {label}
          </NavLink>
        ))}
        <Link to="/" className="ml-auto text-xs text-muted-foreground hover:underline">Siteyi gör</Link>
        <button
          onClick={() => { clearAdminToken(); navigate("/login", { replace: true }); }}
          className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs text-muted-foreground hover:bg-secondary"
        >
          <LogOut className="h-3.5 w-3.5" aria-hidden /> Çıkış
        </button>
      </nav>
      <Outlet />
    </div>
  );
}
